<template>
  <form
    :name="name"
    :id="_getId()"
    :class="{ [extraClass]: true }"
    @submit="onSubmit"
  >
    <div
      v-for="(field, idx) in fields"
      class="field-wrapper"
      :class="{
        [field.elementType]: true,
        [field.extraClassWrapper]: !!field.extraClassWrapper
      }"
    >
      <div :id="field.name">
        <VFormField
          :key="idx"
          :elementType="field.elementType"
          :innerChildProps="field.innerChildProps"
          :type="field.type"
          :name="field.name"
          :label="field.label"
          :subLabel="field.subLabel"
          :additionalText="field.additionalText"
          :validate="field.validate"
          :placeholder="field.placeholder"
          :classType="field.classType"
          :version="field.version"
          :value="field.value"
          :hideLabel="field.hideLabel"
          :layout="field.layout"
          :formName="name"
          :selectItems="field.selectItems"
          :switcherKeys="field.switcherKeys"
          :onClickHandler="field.onClickHandler"
          :switcherType="field.switcherType"
          :uploaderType="field.uploaderType"
          :multiple="field.multiple"
          :extraClass="field.extraClass"
          :extraClassRoot="field.extraClassRoot"
          :position="field.position"
          :onAddHandler="field.onAddHandler"
          :onRemoveHandler="field.onRemoveHandler"
          :names="field.names"
          :isLoading="field.isLoading"
          :disabled="field.disabled"
          :hint="field.hint"
          :valueValidationFunc="field.valueValidationFunc"
          :withFilter="field.withFilter"
          :preventEllipsis="field.preventEllipsis"
          :connectedWith="field.connectedWith"
          :isRequired="field.isRequired"
          :minValuesCount="field.minValuesCount"
          :maxLength="field.maxLength"
          :onSearchAsyncHandler="field.onSearchAsyncHandler"
          @change="val => $emit('change', val)"
          @blur="$emit('blur')"
        ></VFormField>
      </div>
      <VFieldConnector
        v-if="field.connectedWith"
        :ids="[field.name, field.connectedWith]"
      ></VFieldConnector>
    </div>

    <div
      class="submit-btn-wrapper"
      v-if="submitButton"
      :class="{ [submitButton.position]: true }"
    >
      <VButton
        :type="submitButton.classType"
        :label="submitButton.label"
        :disabled="disabled"
        :form="name"
        submit
      ></VButton>
    </div>
  </form>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";
import { mapActions } from "vuex";

// components
import VFormField from "@/components/VFormField";
import VFieldConnector from "@/components/VFieldConnector";
import VButton from "@/components/VButton";

export default Vue.component("VForm", {
  props: {
    name: VueTypes.string.isRequired,
    fields: VueTypes.array.isRequired,
    title: VueTypes.string,
    submitButton: VueTypes.shape({
      label: VueTypes.string,
      classType: VueTypes.oneOf([
        "primary",
        "secondary",
        "tertiary",
        "dark"
      ]).def("primary"),
      position: VueTypes.oneOf(["left", "right", "center"]).def("center")
    }),
    initialValues: VueTypes.object,
    disabled: VueTypes.bool.def(false),
    id: Vue.string,
    extraClass: VueTypes.string.def("")
  },

  components: {
    VFormField,
    VFieldConnector,
    VButton
  },

  computed: {
    getForm() {
      return this.$store.state.forms[this.name];
    }
  },

  methods: {
    onSubmit(e) {
      e.preventDefault();
      this.$emit("submit", this.getForm.values);
    },

    _getId() {
      return this.id ? this.id : this.name;
    },

    ...mapActions("forms", [
      "registerForm",
      "registerFields",
      "validateFields",
      "isValid",
      "initializeForm"
    ])
  },

  created() {
    const formData = { formName: this.name, fields: this.fields };
    if (!this.getForm) {
      this.registerForm(formData);
    }
    // if (Object.keys(this.getForm.fields).length !== this.fields.length)
    else {
      this.registerFields(formData);
    }

    if (this.initialValues && Object.keys(this.initialValues).length) {
      this.initializeForm({ formName: this.name, fields: this.initialValues });
    }
  }
});
</script>

<style lang="scss">
form {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  position: relative;
}

.field-wrapper {
  width: 100%;

  margin-bottom: 30px;

  &.checkbox,
  &:last-child {
    margin-bottom: 0;
  }
}

.submit-btn-wrapper {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 12px;

  &.left {
    justify-content: flex-start;
  }

  &.right {
    justify-content: flex-end;
  }
}
</style>
